import React, { Component } from 'react';
import loading from './loading.svg';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import store from '../reducers/redux-index';

class Callback extends Component {
  render() {
    //console.log("User: ", this.props.user)
    if (this.props.user && this.props.user.logged) {
      return <Redirect to="/" />
    }
    const style = {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
    }

    return (
      <div style={style}>
        <img src={loading} alt="loading"/>
      </div>
    );
  }
}

export default connect((state) => {
  return { user: state.reducerUser }
})(Callback);
